module.exports = __webpack_public_path__ + "static/media/Histograms-of-Weekdays.f01895ff.png";